import type { ExtractResult } from './briefblip';

export function resultToMarkdown(r: ExtractResult): string {
  const lines: string[] = [];
  lines.push(`# ${r.title || 'Meeting brief'}`);
  lines.push('');

  if (r.recap) {
    lines.push('## Recap');
    lines.push(r.recap);
    lines.push('');
  }

  lines.push('## Decisions');
  if (r.decisions.length) {
    r.decisions.forEach((d) => lines.push(`- ${d}`));
  } else {
    lines.push('_None recorded._');
  }
  lines.push('');

  lines.push('## Action items');
  if (r.action_items.length) {
    r.action_items.forEach((a) =>
      lines.push(`- [ ] ${a.text}${a.owner ? ` _(${a.owner})_` : ''}`),
    );
  } else {
    lines.push('_None recorded._');
  }
  lines.push('');

  lines.push('## Next steps');
  if (r.next_steps.length) {
    r.next_steps.forEach((s) => lines.push(`- ${s}`));
  } else {
    lines.push('_None recorded._');
  }
  lines.push('');

  lines.push('---');
  lines.push('_Generated by BriefBlip — a Blue Note Logic Inc. product._');
  return lines.join('\n');
}
